// components/StarRating.jsx
import React from "react";
import { FaStar } from "react-icons/fa";

const Star = ({ fill = 1 }) => {
  const adjustedFill = Math.max(0, Math.min(1, fill)) * 100;

  return (
    <span
      style={{
        display: "inline-block",
        position: "relative",
        width: "14px",
        height: "14px",
      }}
    >
      {/* Border star (outline) */}
      <FaStar
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          color: "#ffd9002b",
          stroke: "#ffd9008a", // gold border
          strokeWidth: "15",
          fontSize: "14px",
        }}
      />

      {/* Filled portion */}
      <span
        style={{
          position: "absolute",
          top: "-5px",
          left: 0,
          width: `${adjustedFill}%`,
          overflow: "hidden",
          fontSize: "14px",
          color: "#FFD700",
          whiteSpace: "nowrap",
        }}
      >
        <FaStar style={{ fontSize: "14px" }} />
      </span>
    </span>
  );
};

const StarRating = ({ rating = 0 }) => {
  const stars = [];

  for (let i = 0; i < 5; i++) {
    const remaining = rating - i;
    let fill = 0;

    if (remaining >= 1) {
      fill = 1;
    } else if (remaining > 0) {
      fill = remaining;
    }

    stars.push(<Star key={i} fill={fill} />);
  }

  return (
    <div
      style={{
        display: "flex",

        alignItems: "center",
        gap: "1rem",
        direction: "ltr",
      }}
    >
      <span
        style={{
          display: "flex",
          gap: ".3rem",
        }}
      >
        {stars}
      </span>
      <span>({rating})</span>
    </div>
  );
};

export default StarRating;
